var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3588 14.2961L4.35 13.9252V15V34.5C4.35 35.1904 4.90965 35.75 5.6 35.75H45.4C46.0904 35.75 46.65 35.1904 46.65 34.5V15V13.9252L45.6412 14.2961L25.5 21.7009L5.3588 14.2961ZM4.35 10V10.5233L4.8412 10.7039L25.2412 18.2039L25.5 18.2991L25.7588 18.2039L46.1588 10.7039L46.65 10.5233V10V5.5C46.65 4.80964 46.0904 4.25 45.4 4.25H5.6C4.90964 4.25 4.35 4.80965 4.35 5.5V10ZM2.01881 38L1.50676 38.5223L2.01881 38C1.20462 37.2018 0.75 36.1223 0.75 35V5C0.75 3.87768 1.20462 2.79825 2.01881 2.00002C2.8335 1.2013 3.94157 0.75 5.1 0.75H45.9C47.0584 0.75 48.1665 1.2013 48.9812 2.00002C49.7954 2.79825 50.25 3.87768 50.25 5V35C50.25 36.1223 49.7954 37.2018 48.9812 38C48.1665 38.7987 47.0584 39.25 45.9 39.25H5.1C3.94157 39.25 2.8335 38.7987 2.01881 38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e9a0a67a70876f423e240941216d42e4.svg";
export { ForwardRef as ReactComponent };